export const messiers = [
    {
        name: "M1",
        type: "nebula",
        catalog: "Messiers",
        description: "Crab Nebula",
        images: [
            {url: "images/astro/messier/m1-2024-04.jpg", year: "2024", month: "04"},
        ]
    },
    {
        name: "M16",
        type: "nebula",
        catalog: "Messiers",
        description: "Eagle Nebula",
        images: [
            {url: "images/astro/messier/m16-2024.jpg", year: "2024", month: "04"},
        ]
    },
    {
        name: "M31",
        type: "galaxy",
        catalog: "Messiers",
        description: "Andromeda Galaxy",
        images: [
            {url: "images/astro/messier/M31-2022-08-09T20.16.36.png", year: "2022", month: "08"},

        ]
    },
    {
        name: "M42",
        type: "nebula",
        catalog: "Messiers",
        description: "Orion Nebula",
        images: [
            {url: "images/astro/messier/m42-2024.png", year: "2024", month: "03"},
            {url: "images/astro/messier/m42-2022-02-26T21.08.56.png", year: "2022", month: "02"},
            {url: "images/astro/messier/m42-2021-12-20T23.09.37.png", year: "2021", month: "12"},

        ]
    },

    {
        name: "M51",
        type: "galaxy",
        catalog: "Messiers",
        description: "Whirlpool Galaxy",
        images: [
            {url: "images/astro/messier/m51-2024-06-28-2.jpg", year: "2024", month: "06"},
            {url: "images/astro/messier/m51-2024-06-28-1.jpg", year: "2024", month: "06"},
            {url: "images/astro/messier/m51-2024-04.jpg", year: "2024", month: "04"},
        ]
    },
    {
        name: "M81",
        catalog: "Messiers",
        type: "galaxy",
        description: "Bode's Galaxy",
        images: [
            {url: "images/astro/messier/m81-2022-08-08T13.58.01.png", year: "2022", month: "08"},
        ]
    },
    {
        name: "M101",
        catalog: "Messiers",
        type: "galaxy",
        description: "Pinwheel Galaxy",
        images: [
            {url: "images/astro/messier/m101-2024-04.jpg", year: "2024", month: "04"},
        ]
    }
]

export const ngc = [
    {
        name: "NGC3371",
        catalog: "NGC",
        type: "galaxy",
        description: "Spiral Galaxy",
        images: [
            {url: "images/astro/ngc/NGC3371-2024-04.jpg", year: "2024", month: "04"},
        ]
    }
]

export const ic = []

export const planets = [
    {
        name: "Jupiter",
        type: "planet",
        description: "",
        images: [{
            url: "images/astro/planets/jupiter-2023.jpg",
            year: "2024", month: "06"
        }]
    }
]

export const misc = [
    {
        name: "Conjonction",
        type: "conjonction",
        catalog: "",
        description: "Saturne and Jupiter in 2023 on the same sensor",
        images: [{
            url: "images/astro/misc/conjonction-2023.jpg",
            year: "2023",
            month: "09"
        }]
    },
    {
        name: "13P/Olbers",
        type: "comet",
        catalog: "",
        description: "Comète 13P/Olbers en 2024",
        images: [
            {url: "images/astro/misc/13P-2024-06.jpg", year: "2024", month: "06"},
        ]
    },
    {
        name: "todo",
        type: "todo",
        catalog: "todo",
        description: "todo",
        images: [
            {url: "images/astro/misc/466663619_18543429700016325_9146382172835995628_n-2.jpg", year: "2024", month: "06"},
        ]
    }
]

export const setup = [

]